import { render, staticRenderFns } from "./withdrawList.vue?vue&type=template&id=0d5993c5&"
import script from "./withdrawList.vue?vue&type=script&lang=js&"
export * from "./withdrawList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports